import { defineActions } from './defineActions'

/**
 * Cancellation. Action names start with Cancellation (CancellationSection is shared between
 * modules; the module comes from the page's subject).
 *
 * The section's Save is the page footer's Ime.Cancellation.Save (ime-page.ts). Changing the
 * cancellation status only stages the change locally until that Save.
 */
export const cancellationActions = defineActions({
  'Cancellation.ResendStaffPicNotice': {
    label: 'Resend cancellation notice to staff PIC',
    area: 'Cancellation',
  },
  'Cancellation.ResendInterpreterNotice': {
    label: 'Resend cancellation notice to interpreter',
    area: 'Cancellation',
  },
  'Cancellation.ResendClaimantNotice': {
    label: 'Resend cancellation notice to claimant/examinee',
    area: 'Cancellation',
  },
  'Cancellation.ResendSolicitorNotice': {
    label: 'Resend cancellation notice to booking solicitor',
    area: 'Cancellation',
  },
  'Cancellation.ResendBookingCmNotice': {
    label: 'Resend cancellation notice to booking CM',
    area: 'Cancellation',
  },
  'Cancellation.ResendSpecialistNotice': {
    label: 'Resend cancellation notice to specialist',
    area: 'Cancellation',
  },
  'Cancellation.ResendSpecialistAmNotice': {
    label: 'Resend cancellation notice to account manager of specialist',
    area: 'Cancellation',
  },
  'Cancellation.ResendSurrogateClinicNotice': {
    label: 'Resend cancellation notice to surrogate clinic centre',
    area: 'Cancellation',
  },
  'Cancellation.ResendReschedulingReminder': {
    label: 'Resend rescheduling reminder to staff PIC',
    area: 'Cancellation',
    description:
      'Resend > To Rescheduling Reminders (cancellation notice) or To Staff PIC (rescheduling reminders): the same email.',
  },
  'Cancellation.ResendReschedulingReminderToCm': {
    label: 'Resend rescheduling reminder to booking CM',
    area: 'Cancellation',
  },
})
